import workspaceQuery from '../../../graphql/queries/bank/BankPaymentReceiptWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/bank/BankPaymentReceiptQuery.graphql';
import defaultQuery from '../../../graphql/queries/bank/BankPaymentReceiptDefault.graphql';
import mutationQuery from '../../../graphql/mutations/bank/BankPaymentReceiptMutation.graphql';
import temporaryMutationQuery from '../../../graphql/mutations/bank/SaveBankPaymentReceiptTempMutation.graphql';
import fragment from '../../../graphql/fragments/bank/BankPaymentReceiptFragment.graphql';

import { EntityType } from '../../../@types/entityTypes';
import { formActionsForPermissions } from '../../../actions/bank/BankPaymentReceiptAction';

const BankPaymentReceipt: EntityType = {
  type: 'BankPaymentReceipt',
  title: 'Bank Payments/Receipts',
  formUrl: '/Bank/PaymentReceipt/Details/',
  formTitle: 'Bank Payments/Receipts',
  workspaceUrl: '/Bank/PaymentReceipt/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  fragment,
  screenReference: 'BANK_PAYMENT_RECEIPT',
  actions: [...formActionsForPermissions],
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED', 'PENDING'],
    },
  ],
};

export default BankPaymentReceipt;
